/*
	© 2020 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

define("Code25.CaterpartsGlobal.CatCollection", ["underscore", "Item.Collection"], function (_, ItemCollection) {


var ItemRelationsRelatedCollection = ItemCollection.extend({
    initialize: function(options) {
        
        this.searchApiMasterOptions={fieldset: 'search', commercecategoryurl: options.categoryUrl,offset:0,limit:options.limit||8,offset:options.offset||0,use_pcv:"F",sort:"custitem_c25_last2yearssales"};
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        return this.fetch();
    },

    parse: function(response) {
        var original_items = _.compact(response.items);

        if (original_items.length === 0) {
            return []; // No items. Return an empty array, nothing else to do here.
        }

    
        if (original_items.length === 1) {
            return (original_items[0]).relateditems_detail; // Same order is preserved.
        }

        return original_items;
    }
});

return ItemRelationsRelatedCollection;

});
